<template>
  <vue-particles
    v-if="show"
    :class="[$style.wrapper, 'particle-background']"
    :style="backgroundStyle"
    :color="particleOptions.color"
    :particleOpacity="particleOptions.particleOpacity"
    :particlesNumber="particleOptions.particlesNumber"
    :shapeType="particleOptions.shapeType"
    :particleSize="particleOptions.particleSize"
    :linesColor="particleOptions.linesColor"
    :linesWidth="particleOptions.linesWidth"
    :lineLinked="particleOptions.lineLinked"
    :lineOpacity="particleOptions.lineOpacity"
    :linesDistance="particleOptions.linesDistance"
    :moveSpeed="particleOptions.moveSpeed"
    :hoverEffect="particleOptions.hoverEffect"
    :hoverMode="particleOptions.hoverMode"
    :clickEffect="particleOptions.clickEffect"
    :clickMode="particleOptions.clickMode"
    >
  </vue-particles>
</template>

<script>
import { cloneDeep } from 'lodash';

import DashboardConst from '@/constants/dashboard';

import BackgroundOption from '@/views/dashboard/data/background-option';

export default {
  name: 'WParticleBackground',
  components: {
  },
  props: {
    options: {
      type: Object,
      default() {},
    },
  },
  data() {
    return {
      show: true,
    };
  },
  computed: {
    particleOptions() {
      const option = cloneDeep(BackgroundOption[this.options.type || DashboardConst.BACKGROUND_ANIMATION_TYPE.PARTICLE]);

      option.color = this.options.color || option.color;
      option.linesColor = this.options.color || option.color;
      option.backgroundColor = this.options.backgroundColor || option.backgroundColor;

      return option;
    },
    backgroundStyle() {
      return {
        'background-color': this.particleOptions.backgroundColor,
      };
    },
  },
  watch: {
    options: {
      immediate: true,
      deep: true,
      handler() {
        // 속성이 변경되면 vue-particles을 파괴했다가 다시 생성한다. (이유는 prop로 넘긴 속성이 곧바로 적용되않는다..)
        this.show = false;
        this.$nextTick(() => {
          this.show = true;
        });
      },
    },
  },
  methods: {},
};
</script>

<style module>
.wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/frame/ParticleBackground.vue